
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const whatsappMessage = encodeURIComponent("Hello 👋 The Tooth Doctor,\nI would like to book an appointment / make an enquiry about your dental services.\nPlease share available slots and details.");
  const whatsappUrl = `https://wa.me/916369090441?text=${whatsappMessage}`;

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(1, 43, 83, 0.8), rgba(1, 43, 83, 0.7)), url('https://readdy.ai/api/search-image?query=Modern%20dental%20clinic%20interior%20with%20comfortable%20patient%20chair%2C%20advanced%20dental%20equipment%2C%20bright%20clean%20environment%2C%20professional%20medical%20setting%2C%20calming%20blue%20and%20white%20color%20scheme%2C%20natural%20lighting%2C%20contemporary%20design&width=1920&height=1080&seq=hero-dental-clinic&orientation=landscape')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#012B53]/90 to-[#012B53]/70"></div>
      
      <div className="relative z-10 w-full mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
            Advanced Dental Care in 
            <span className="text-yellow-300"> Thiruverkadu, Chennai</span>
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8 text-blue-100 max-w-3xl mx-auto px-4">
            Smile Brighter with Expert Dental Care. Experience pain-free, affordable dental treatments with our team of experienced dentists.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-8 sm:mb-12 px-4">
            <Button 
              size="lg" 
              variant="secondary"
              onClick={() => window.open(whatsappUrl, '_blank')}
              className="w-full sm:w-auto min-w-[200px]"
            >
              <i className="ri-calendar-line mr-2"></i>
              Book Appointment
            </Button>
            
            <Button 
              size="lg" 
              variant="outline"
              className="w-full sm:w-auto min-w-[200px] border-white text-white hover:bg-white hover:text-[#012B53]"
            >
              <a href="tel:+916369090441" className="flex items-center justify-center w-full">
                <i className="ri-phone-line mr-2"></i>
                Call Now
              </a>
            </Button>
            
            <Button 
              size="lg" 
              variant="ghost"
              className="w-full sm:w-auto min-w-[200px] text-white hover:bg-white/20"
            >
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full">
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </a>
            </Button>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto px-4">
            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-user-heart-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-semibold mb-2">Expert Dentists</h3>
              <p className="text-blue-100 text-sm sm:text-base">Experienced team of dental professionals</p>
            </div>
            
            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-shield-check-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-semibold mb-2">Pain-Free Treatment</h3>
              <p className="text-blue-100 text-sm sm:text-base">Advanced techniques for comfortable care</p>
            </div>
            
            <div className="text-center sm:col-span-2 md:col-span-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-time-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-semibold mb-2">Flexible Hours</h3>
              <p className="text-blue-100 text-sm sm:text-base">Convenient appointment scheduling</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-xl sm:text-2xl"></i>
      </div>
    </section>
  );
}
